// useUserProfileStore.ts

import { create } from 'zustand';
import { UserOrgProfileDto } from 'nexgen-types';

export const useUserProfileStore = create<{
  profile: (UserOrgProfileDto & { name: string }) | null;
  setProfile: (profile: UserOrgProfileDto) => void;
  clear: () => void;
}>((set) => ({
  profile: null,

  setProfile: (profile) => {
    const name =
      [profile.first_name, profile.last_name].filter(Boolean).join(' ').trim() ||
      profile.moniker ||
      '';
    set({ profile: { ...profile, name } });
  },

  clear: () => set({ profile: null }),
}));
